import { Close } from "components/icons";
import Translate from "lang/Translate"

interface ErrorModalProps {
    title: string,
    onClose: () => void,
    children: React.ReactNode,
    className?: string
}

const ErrorModal = (props: ErrorModalProps) => {
    return (
        <div data-testid="def-modal" className="modal is-active">
            <div className="modal-background"></div>
            <div className="modal-card">
                <header className="modal-card-head border-bottom">
                    <p className="modal-card-title" ><Translate text="Content.title_default" /> </p>
                    <div data-testid="model-close-icon" className='flex-center pointer' onClick={props.onClose}>
                        <Close />
                    </div>
                </header>
                <section className="modal-card-body">
                    {props.children}
                </section>
                {/* <footer className="modal-card-foot">
                    <button className="button is-success" onClick={props.onClose}>Close</button>
                </footer> */}
            </div>
        </div>
    );
};


export default ErrorModal;
